import api from 'utils/api-controller';
import Emitter from 'utils/event-emitter';
import utils from 'utils/utils';
import _ from 'lodash';
import sysCtrl from 'controllers/sys-ctrl';

var cotacaoCtrl = {

  DATA_EVENT: 'cotacao',

  emitter: new Emitter(),

  data: {
    currentPage: 0,
    itemsPerPage: 10,
    edit: {}
  },

  dadosFornec: {},

  mixin: {

    componentDidMount() {
      cotacaoCtrl.emitter.addEventListener(cotacaoCtrl.DATA_EVENT,this.refreshData);
      cotacaoCtrl.requestData(true);
    },

    componentWillUnmount(){
      cotacaoCtrl.emitter.removeEventListener(cotacaoCtrl.DATA_EVENT,this.refreshData);
    },

    refreshData(){
      this.setState({});
    }

  },

  _sortByDescricao(a,b){
    var aDesc = a.descricao.toLowerCase();
    var bDesc = b.descricao.toLowerCase();
    return ((aDesc < bDesc) ? -1 : ((aDesc > bDesc) ? 1 : 0));
  },

  _sortByNome(a,b){
    var aNome = a.nome.toLowerCase();
    var bNome = b.nome.toLowerCase();
    return ((aNome < bNome) ? -1 : ((aNome > bNome) ? 1 : 0));
  },

  requestData(isOnLoading){

    api.get('/cotacao/dados').success(function(data){
        var grupos = [], marcas = [];
        cotacaoCtrl.data = data;//;utils.extend(cotacaoCtrl.data, data);

        cotacaoCtrl.data.currentPage = 0;
        cotacaoCtrl.data.itemsPerPage = 10;
        cotacaoCtrl.data.edit = {};

        if (cotacaoCtrl.data.itens) {
          cotacaoCtrl.data.itens.sort(cotacaoCtrl._sortByDescricao);
          cotacaoCtrl.data.itens.forEach(function(item){
            if (!$.grep(grupos,(g) => g.nome == item.grupo)[0]) grupos.push({id: item.grupo, nome: item.grupo});
            if (!$.grep(marcas,(m) => m.nome == item.marca)[0]) marcas.push({id: item.marca, nome: item.marca});
          });
        }

        grupos.sort(cotacaoCtrl._sortByNome);
        marcas.sort(cotacaoCtrl._sortByNome);

        grupos.unshift({id:-1, nome: 'Todos'});
        marcas.unshift({id:-1, nome: 'Todas'});

        cotacaoCtrl.data.grupos = grupos;
        cotacaoCtrl.data.marcas = marcas;

        cotacaoCtrl.data.filtroGrupo = -1;
        cotacaoCtrl.data.filtroMarca = -1;

        if ((data.fornecedor > -1) && isOnLoading) {
          cotacaoCtrl.requestFornecedor(data.fornecedor);
        }

        cotacaoCtrl.data.currentPage = 0;
        cotacaoCtrl.emitter.emit(cotacaoCtrl.DATA_EVENT);
    });
  },

  requestFornecedor(idFornec){
    return api.get('/cotacao/fornecedor/'+idFornec).success(function(data){
      cotacaoCtrl.dadosFornec = data;
      cotacaoCtrl.setValue('fornecedor', idFornec);
    });
  },

  setValue(propName,propValue){
    cotacaoCtrl.data[propName] = propValue;
    cotacaoCtrl._finishNavigation();
  },

  emitChange(){
    cotacaoCtrl.emitter.emit(cotacaoCtrl.DATA_EVENT);
  },

  getFilteredItems(){
    var itens = cotacaoCtrl.data.itens || [];
    return itens.filter((item) => {
      if (cotacaoCtrl.data.filtroGrupo != -1 && item.grupo != cotacaoCtrl.data.filtroGrupo) return false;
      if (cotacaoCtrl.data.filtroMarca != -1 && item.marca != cotacaoCtrl.data.filtroMarca) return false;
      return true;
    });
  },

  getItemOfPage(){
    var items = [];
    var pos = (cotacaoCtrl.data.currentPage * cotacaoCtrl.data.itemsPerPage);
    var count = 0;
    while (count < cotacaoCtrl.data.itemsPerPage && pos < cotacaoCtrl.getFilteredItems().length) {
      items.push(cotacaoCtrl.getFilteredItems()[pos]);
      count++;
      pos++;
    }
    return items;
  },

  getPageCount(){
    return Math.ceil(cotacaoCtrl.getFilteredItems().length / cotacaoCtrl.data.itemsPerPage);
  },

  getCurPageLabel(){
    return ((cotacaoCtrl.data.currentPage+1) + '/' + cotacaoCtrl.getPageCount());
  },

  isFirstPage(){
    return cotacaoCtrl.data.currentPage == 0;
  },

  isLastPage(){
    return (cotacaoCtrl.data.currentPage == cotacaoCtrl.getPageCount()-1);
  },

  _finishNavigation(){
    if (cotacaoCtrl.data.currentPage >= cotacaoCtrl.getPageCount()) {
      cotacaoCtrl.data.currentPage = cotacaoCtrl.getPageCount()-1;
    }
    cotacaoCtrl.emitChange();
  },

  goNextPage(){
    if (!cotacaoCtrl.isLastPage()) {
      cotacaoCtrl.data.currentPage++;
      cotacaoCtrl._finishNavigation();
    }
  },

  goPriorPage(){
    if (!cotacaoCtrl.isFirstPage()) {
      cotacaoCtrl.data.currentPage--;
      cotacaoCtrl._finishNavigation();
    }
  },

  goFirstPage(){
    cotacaoCtrl.data.currentPage = 0;
    cotacaoCtrl._finishNavigation();
  },

  goLastPage(){
    cotacaoCtrl.data.currentPage = cotacaoCtrl.getPageCount()-1;
    cotacaoCtrl._finishNavigation();
  },

  setFiltroGrupo(value){
    cotacaoCtrl.setValue('filtroGrupo',value);
  },

  setFiltroMarca(value){
    cotacaoCtrl.setValue('filtroMarca',value);
  },

  findItemFor(item){
    if (!cotacaoCtrl.dadosFornec || !cotacaoCtrl.dadosFornec.itens) return;
    return $.grep(cotacaoCtrl.dadosFornec.itens,(itfor) => itfor.idItem == item.id)[0];
  },

  getDadosItemFor(item){
    var data = {
      precos: [],
      obs: ''
    };

    var itemFor = cotacaoCtrl.findItemFor(item);

    if (itemFor) {
      data.precos = itemFor.precos;
      data.obs = itemFor.obs;
    }

    _.each(data.precos,(p) => data['preco'+p.prazo] = p.preco);

    return data;
  },

  selectItem(item){
    if (item == undefined) {
      cotacaoCtrl.data.edit = {};
      cotacaoCtrl.setValue('selectedItem', undefined);
    } else if (item !== cotacaoCtrl.data.selectedItem) {
      cotacaoCtrl.data.edit = cotacaoCtrl.getDadosItemFor(item);
      cotacaoCtrl.setValue('selectedItem', item);
    }
  },

  setEditErrorMessage(message){
    cotacaoCtrl.data.edit.errorMessage = message;
    cotacaoCtrl.emitChange();
  },

  setOfertaErrorMessage(message){
    if (message) {
      cotacaoCtrl.ofertaErrorMessage = message;
    } else {
      delete cotacaoCtrl.ofertaErrorMessage;
    }
    cotacaoCtrl.emitChange();
  },

  delItemFornec(item){
    var payload = {
      idItem: item.id,
      idFornecedor: cotacaoCtrl.data.fornecedor
    };

    return api.post('/cotacao/remitem', payload).success(function(){
      cotacaoCtrl.dadosFornec.itens = cotacaoCtrl.dadosFornec.itens.filter((item) => item.idItem != payload.idItem);
      cotacaoCtrl.emitChange();
    });

  },

  saveItemFornec(){

    var payload = {
      idItem: cotacaoCtrl.data.selectedItem.id,
      obs: cotacaoCtrl.data.edit.obs,
      idFornecedor: cotacaoCtrl.data.fornecedor,
      precos: []
    };

    _.each(sysCtrl.data.condicoesPreco, (p) => {

      var vPreco = utils.toNumber(cotacaoCtrl.data.edit['preco'+p]);

      if (!isNaN(vPreco)) {
        var itemPreco = {
          prazo: p,
          preco: vPreco
        };
        payload.precos.push(itemPreco);
      }

    });

    return api.post('/cotacao/saveitemfor',payload).success(function(){

      var itemFor = _.find(cotacaoCtrl.dadosFornec.itens,(item) => item.idItem == payload.idItem);

      //salva o item do fornecedor
      if (!itemFor) {
        itemFor = {
          idItem: payload.idItem,
          obs: payload.obs,
          precos: payload.precos
        };
        cotacaoCtrl.dadosFornec.itens.push(itemFor);
      } else {
        itemFor.obs = payload.obs;
        itemFor.precos = payload.precos;
      }

    });

  },

  savePrecoItemFornec(payload){

    utils.toNumber(payload,['preco']);

    if (isNaN(payload.preco)) {
      cotacaoCtrl.setEditErrorMessage('Por favor, informe um preço válido');
      return;
    }

    return api.post('/cotacao/setprecoitem', payload).success(function(){

      var itemFor = _.find(cotacaoCtrl.dadosFornec.itens,(item) => item.idItem == payload.idItem);

      //salva o item do fornecedor
      if (!itemFor) {
        itemFor = {
          idItem: payload.idItem,
          obs: payload.obs,
          precos: []
        };
        cotacaoCtrl.dadosFornec.itens.push(itemFor);
      } else {
        itemFor.obs = payload.obs;
      }

      //salva o preco do item
      var itemPreco = _.find(itemFor.precos, (p) => p.prazo == payload.prazo);

      if (itemPreco) {
        itemPreco.preco = payload.preco;
      } else {
        itemPreco = {
          prazo: payload.prazo,
          preco: payload.preco
        };
        itemFor.precos.push(itemPreco);
      }

    });

  },

  linkState(propName){
    return {
      value: cotacaoCtrl.data.edit[propName],
      requestChange(newValue){
        cotacaoCtrl.data.edit[propName] = newValue;
        cotacaoCtrl.emitChange();
      }
    }
  },

  // oferta

  removeItemOferta(item){
    return api.del('/oferta/'+item.id).success(function(){
      cotacaoCtrl.dadosFornec.ofertas = cotacaoCtrl.dadosFornec.ofertas.filter((o) => o.id !== item.id);
      cotacaoCtrl.emitChange();
    });
  },

  saveItemOferta(item){

    var payload = utils.extend({},item);

    payload.dtValidadeOferta = payload.dtValidadeOferta.toDate().getTime();
    if (payload.dtValidadeProduto) payload.dtValidadeProduto = payload.dtValidadeProduto.toDate().getTime();
    payload.idFornecedor = cotacaoCtrl.data.fornecedor;
    utils.toNumber(payload,['embalagem','preco','prazoPagamento','prazoEntrega']);

    return api.post('/oferta',payload).success(function(returnedItem){
      var list = cotacaoCtrl.dadosFornec.ofertas;
      if (item.id) {
        var pos = 0;
        list.forEach((o,i) => {if (o.id == item.id) pos = i; });
        list[pos] = returnedItem;
      } else {
        list.push(returnedItem);
      }
    });
  },

  requestProd(codEan){
    return api.get('/oferta/ean/'+codEan);
  }

};

module.exports = cotacaoCtrl;


/** WEBPACK FOOTER **
 ** ./src/controllers/cotacao-ctrl.js
 **/